import { fork } from 'redux-saga/effects';
import * as sectors from './sectors';
import * as accounts from './accounts';
import * as agents from './agents';
import * as projects from './projects';
import * as root from './root';
import * as reports from './reports';
import * as tasks from './tasks';
import * as submissions from './submissions';
import * as taskForms from './task-forms';

export default function* rootSaga() {
  const functions = [
    ...Object.values(sectors.watchers),
    ...Object.values(accounts.watchers),
    ...Object.values(agents.watchers),
    ...Object.values(projects.watchers),
    ...Object.values(root.watchers),
    ...Object.values(reports.watchers),
    ...Object.values(tasks.watchers),
    ...Object.values(submissions.watchers),
    ...Object.values(taskForms.watchers)
  ];

  yield functions.map(fn => fork(fn));
}



// WEBPACK FOOTER //
// ./src/sagas/index.js